<template>
  <div class="container mt-4" >
    
    <!-- 1. لوحة التحكم: إعداد المواد والتواريخ -->
    <div class="card shadow-sm mb-4 border-top-primary no-print">
      <div class="card-header bg-white py-3">
        <h5 class="mb-0 text-primary fw-bold">
          <i class="fas fa-calendar-alt ms-2"></i> إعداد جدول الامتحانات للكشف
        </h5>
      </div>
      <div class="card-body">
        
        <!-- إعدادات الكشف الأساسية -->
        <div class="row g-3 mb-4">
          <div class="col-md-4">
            <label class="fw-bold">الفصل الدراسي</label>
            <select v-model="form.term_id" class="form-select">
              <option v-for="t in terms" :key="t.id" :value="t">{{ t.name }}</option>
            </select>
          </div>
          <div class="col-md-4">
            <label class="fw-bold">مقر اللجنة</label>
            <select v-model="form.committee_id" class="form-select">
              <option v-for="c in committees" :key="c.id" :value="c.id">{{ c.commitee_name }}</option>
            </select>
          </div>
          <div class="col-md-4 d-flex align-items-end">
            <button @click="fetchReport" class="btn btn-primary w-100 fw-bold" :disabled="loading">
              <i class="fas fa-search ms-2"></i> جلب الطلاب
            </button>
          </div>
        </div>

        <!-- إعداد المواد والتواريخ (ديناميكي) -->
        <h6 class="fw-bold border-bottom pb-2 mb-3 text-muted">
            <i class="fas fa-edit ms-1"></i> تخصيص أعمدة المواد في الكشف:
        </h6>
        <div class="row g-2 mb-3 align-items-stretch">
    
    <!-- حلقة التكرار للمواد -->
    <div class="col-6 col-md-4 col-lg-2" v-for="(sub, index) in subjectsList" :key="index">
        <div class="subject-card p-2 border rounded bg-white h-100 d-flex flex-column justify-content-center position-relative shadow-sm hover-shadow">
            
            <!-- زر الحذف (يظهر بشكل عائم ومنسق) -->
            <button 
                v-if="subjectsList.length > 1" 
                @click="removeSubjectColumn(index)" 
                class="btn btn-danger btn-sm rounded-circle remove-btn shadow-sm"
                title="إزالة المادة"
            >
                <i class="fas fa-times"></i>
            </button>

            <!-- حقل اسم المادة -->
            <div class="input-group input-group-sm mb-2">
                <span class="input-group-text bg-light text-primary border-0"><i class="fas fa-book"></i></span>
                <input 
                    type="text" 
                    v-model="sub.name" 
                    class="form-control border-light bg-light fw-bold text-center" 
                    placeholder="المادة"
                >
            </div>

            <!-- حقل التاريخ -->
            <div class="input-group input-group-sm">
                <span class="input-group-text bg-light text-secondary border-0"><i class="far fa-calendar-alt"></i></span>
                <input 
                    type="text" 
                    v-model="sub.date" 
                    class="form-control border-light bg-light text-center" 
                    placeholder="التاريخ"
                >
            </div>

        </div>
    </div>

    <!-- زر الإضافة -->
    <div class="col-6 col-md-4 col-lg-2">
        <button 
            @click="addSubjectColumn" 
            class="btn btn-outline-success border-dashed w-100 h-100 d-flex flex-column align-items-center justify-content-center p-3 add-card-btn"
        >
            <div class="icon-box mb-2"><i class="fas fa-plus fa-lg"></i></div>
            <span class="fw-bold small">إضافة مادة</span>
        </button>
    </div>

</div>
        <div class="mt-4 text-center">
           <button @click="printReport" class="btn btn-dark px-5 fw-bold" :disabled="!processedReportData">
             <i class="fas fa-print ms-2"></i> طباعة الكشف المجمع
           </button>
        </div>

      </div>
    </div>

    <!-- 2. منطقة الطباعة -->
    <div id="printMe" v-if="processedReportData" >
      
      <div v-for="(school, sIdx) in processedReportData" :key="'school-'+sIdx">
        <div v-for="(page, pIdx) in school.pages" :key="'page-'+pIdx" class="print-page-wrapper">
          
          <table class="table table-bordered border-dark text-center align-middle w-100 mb-0 table-print" dir="rtl">
            
            <!-- الترويسة -->
            <thead>
              <tr class="border-0">
                <th :colspan="3 + subjectsList.length" class="border-0 p-0">
                  <div class="report-header mb-2 mt-2">
                    <div class="row text-center align-items-center">
                      <div class="col-4 text-start small-header fs-20">
                        <h6 class="fw-bold mb-0">محافظة شمال سيناء</h6>
                        <h6 class="fw-bold mb-0">لجنة النظام والمراقبة</h6>
                      </div>
                      <div class="col-4">
                        <h4 class="fw-bold text-decoration-underline mb-1 fs-23">كشف توقيع (مجمع)</h4>
                        <div class="badge bg-white text-dark border border-dark px-3 py-1 fs-20">
                          {{ form.term_name }} | 2026
                        </div>
                      </div>
                      <div class="col-4 text-start">
                        <div class="border border-dark p-1 rounded text-center bg-light">
                          <p class="mb-0 fw-bold small fs-20">مقر اللجنة: {{ reportData.committee_name }}</p>
                          <p class="mb-0 fw-bold small fs-18">رقم اللجنة: ( {{ reportData.committee_number }} )</p>
                        </div>
                      </div>
                    </div>
                    <div class="mt-2 bg-dark text-white p-1 text-center rounded">
                       <h5 class="m-0 fw-bold">{{ school.school_name }}</h5>
                    </div>
                  </div>
                </th>
              </tr>

              <!-- عناوين الأعمدة (ديناميكية) -->
              <tr class="table-light custom-th">
                <th width="10%">الجلوس</th>
                <th width="30%">اسم الطالب / الحالة</th>
                <th width="8%">الديانة</th>
                
                <!-- حلقة تكرار لعرض المواد كأعمدة -->
                <th v-for="(sub, i) in subjectsList" :key="'h-'+i" class="subject-col fs-10">
                    {{ sub.name }}
                    <div class="date-sub text-muted mt-1">{{ sub.date }}</div>
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="student in page.students" :key="student.id">
                <td class="fw-bold fs-5 font-monospace">{{ student.Seating_No }}</td>
                <td class="text-start pe-2">
                    <div class="fw-bold fs-16">{{ student.Arabic_Name | truncate(30)}}</div>
                    <div v-if="student.Damg_Status_id" class="text-danger fw-bold small d-inline-block mt-1">
                       <i class="fas fa-wheelchair"></i> دمج
                    </div>
                    <div v-else-if="student.Stud_Type_Id == 2" class="text-secondary fw-bold small d-inline-block mt-1">
                       [ منازل ]
                    </div>
                </td>
                <td>{{ student.Moslem_Name }}</td>

                <!-- خلايا التوقيع الفارغة للمواد -->
                <td v-for="(sub, i) in subjectsList" :key="'c-'+i"></td>
              </tr>
              
              <!-- صفوف فارغة للضبط -->
              <tr v-for="n in (25 - page.students.length)" :key="'empty-'+n" class="empty-row">
                  <td :colspan="3 + subjectsList.length">&nbsp;</td>
              </tr>
            </tbody>
          </table>

          <!-- التذييل -->
          <div class="page-footer mt-1 border-top border-2 border-dark pt-1">
             <div class="row align-items-center">
                 <div class="col-6 text-end small fw-bold">
                    إجمالي: {{ school.stats.total }} (مسلم: {{ school.stats.muslim }} - مسيحي: {{ school.stats.christian }})
                 </div>
                 <div class="col-6 text-start">
                     <span class="fw-bold border border-dark px-2 bg-light small">
                         صـ ( {{ pIdx + 1 }} / {{ school.pages.length }} )
                     </span>
                 </div>
             </div>
             <div class="row mt-2 text-center small fw-bold">
                 <div class="col-4">ملاحظ أول: ............</div>
                 <div class="col-4">ملاحظ ثان: ............</div>
                 <div class="col-4">مراقب الدور: ............</div>
             </div>
          </div>

          <div class="page-break"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/axios';

export default {
  name: "CallingSheetFixedSubjects",
  data() {
    return {
      loading: false,
      terms: [],
      committees: [],
      reportData: null,
      processedReportData: null,
      form: {
        term_id: "",
        term_name: "الفصل الدراسي الأول",
        committee_id: ""
      },
      // قائمة المواد الثابتة (يمكنك تعديلها من الواجهة أو افتراضياً)
      subjectsList: [
          { name: 'عربية', date: 'السبت 18/5' },
          { name: 'إنجليزية', date: 'الأحد 19/5' },
          { name: 'دراسات', date: 'الأثنين 20/5' },
          { name: 'جبر', date: 'الثلاثاء 21/5' },
          { name: 'هندسة', date: 'الثلاثاء 21/5' },
          { name: 'علوم', date: 'الثلاثاء 21/5' },
          { name: 'دين', date: 'الثلاثاء 21/5' },
          { name: 'فنية', date: 'الثلاثاء 21/5' },
          { name: 'حاسب', date: 'الثلاثاء 21/5' },
      ]
    };
  },
            filters: {
    truncate(value, limit) {
        if (!value) return '';
        if (value.length <= limit) return value;
        return value.substring(0, limit) + '...';
    }
},
  mounted() {
    api.get('/getterms').then(res => this.terms = res.data);
    api.get('/admin/getCommittee').then(res => this.committees = res.data);
  },
  methods: {
    addSubjectColumn() {
        this.subjectsList.push({ name: 'مادة جديدة', date: '' });
    },
    removeSubjectColumn() {
        this.subjectsList.pop();
    },
    async fetchReport() {
      if(!this.form.committee_id) return alert('اختر اللجنة');
      this.loading = true;
      try {
        const res = await api.get('/admin/getCommitteeReport', { params: this.form });
        this.reportData = res.data;
        this.processDataPagination();
      } catch (e) { console.error(e); } finally { this.loading = false; }
    },
    processDataPagination() {
        if (!this.reportData) return;
        const ROWS_PER_PAGE = 25;
        this.processedReportData = this.reportData.schools_data.map(school => {
            const pages = [];
            for (let i = 0; i < school.students.length; i += ROWS_PER_PAGE) {
                pages.push({ students: school.students.slice(i, i + ROWS_PER_PAGE) });
            }
            return { ...school, pages };
        });
    },
    printReport() {
      this.$htmlToPaper("printMe");
    }
  }
};
</script>

<style scoped>
.border-top-primary { border-top: 4px solid #0d6efd; }

@media print {
  @page {
    /* تغيير الاتجاه لـ Landscape لاستيعاب أعمدة المواد الكثيرة */
    size: A4 landscape; 
    margin: 5mm;
  }
  body * { visibility: hidden; }
  .no-print { display: none !important; }
  #printMe, #printMe * { visibility: visible; }
  #printMe { position: absolute; left: 0; top: 0; width: 100%; }
  
  .page-break { page-break-after: always; height: 0; display: block; }

  /* تنسيق الجدول */
  .table-print th, .table-print td {
      border: 1px solid #000 !important;
      padding: 2px !important;
      font-size: 11pt !important;
      height: 32px; /* تقليل الارتفاع قليلاً */
  }
  .custom-th th { background-color: #e0e0e0 !important; font-weight: 900; -webkit-print-color-adjust: exact; }
  
  /* تنسيق رأس المادة */
  .date-sub {
      font-size: 9pt;
      border-top: 1px solid #999;
      margin-top: 2px;
      padding-top: 2px;
  }
}
.subject-card {
    transition: all 0.3s ease;
    border: 1px solid #e9ecef !important;
}

.subject-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.1) !important;
}

/* زر الحذف العائم */
.remove-btn {
    position: absolute;
    top: -8px;
    left: -8px; /* يظهر في الركن الأيسر العلوي */
    width: 24px;
    height: 24px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    z-index: 10;
    opacity: 0; /* مخفي افتراضياً */
    transition: opacity 0.2s;
}

/* إظهار زر الحذف عند وقوف الماوس على الكارت */
.subject-card:hover .remove-btn {
    opacity: 1;
}

/* تنسيق زر الإضافة */
.border-dashed {
    border: 2px dashed #198754;
    background-color: #f8fffb;
    transition: all 0.3s;
}

.add-card-btn:hover {
    background-color: #e9f7ef;
    transform: scale(0.98);
}

.icon-box {
    width: 30px;
    height: 30px;
    background-color: #198754;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* تحسين حقول الإدخال */
.input-group-text {
    width: 30px;
    justify-content: center;
}
.form-control:focus {
    box-shadow: none;
    background-color: #fff !important;
    border-color: #198754 !important;
}
</style>